import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const ForgotPasswordLink = styled(Link)`
  text-align: center;
  margin-top: 15px;
  display: block;
`
